import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ScrollArea } from '~/components/shadcn/scroll-area.tsx';
import { WatchlistNavbar } from '~/components/watchlist/watchlist-navbar.tsx';
import { useTranslations } from '~/i18n/use-translations.ts';
import { requireAuthenticatedBeforeLoad } from '~/routing/require-authenticated-before-load.ts';
import { getAppShellDataQueryOptions } from '~/server/app/app-shell-data-query.ts';
import { cn } from '~/utils/cn.ts';

export const Route = createFileRoute('/watchlists/')({
	beforeLoad: requireAuthenticatedBeforeLoad,
	component: WatchlistsIndexPage,
});

function WatchlistsIndexPage() {
	const t = useTranslations();
	const { data } = useSuspenseQuery(getAppShellDataQueryOptions());
	const watchlists = data.watchlists;

	if ((watchlists?.length ?? 0) > 0) {
		return (
			<Navigate
				params={{
					watchlistIndex: '0',
				}}
				to="/watchlists/$watchlistIndex/overview"
			/>
		);
	}

	return (
		<>
			<div className="pr-1 pl-1 sm:pr-3">
				<WatchlistNavbar watchlists={watchlists} />
			</div>
			<ScrollArea
				classNames={{
					root: cn('flex h-watchlist-body-height w-full flex-col pr-1 pl-1 sm:pr-3'),
					viewport: cn('h-watchlist-body-height w-full'),
				}}
			>
				<div className="flex flex-row justify-end gap-x-1 p-2">
					<p className="text-foreground italic">{t('watchlist.empty')}</p>
					<span>😊</span>
				</div>
			</ScrollArea>
		</>
	);
}
